import Ajax from "./Ajax"
const GetLocation = async(cityId,loader) => {
    const response = await Ajax({
        url: `/setting/getLocation?limit=false&city=${cityId}`,
        token: true,
        ...(loader && {loader: true})
    })
    return response.data.result
}
export default GetLocation